import { Component } from 'react';
import withAuth from '../../auth/withAuth';

class Admin extends Component {
	render() {
		if(this.props.user.type==='admin') {
			this.props.history.replace('/admin/organizations/')
			return null;
		} else {
			this.props.history.replace('/admin/organization/'+ this.props.user.organization_id +'/edit')
			return null;
		}
	}
}

export default withAuth(Admin);


// WEBPACK FOOTER //
// ./src/modules/admin/organization/Admin.js